import { Button as ButtonPrimitive } from "@base-ui/react/button";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";
import { cn } from "./cn";

const buttonVariants = cva(
  "inline-flex select-none items-center justify-center gap-2 whitespace-nowrap rounded-[10px] border font-semibold outline-none transition-[transform,background-color,border-color,color] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--paper)] disabled:pointer-events-none disabled:opacity-45 active:scale-[0.97]",
  {
    variants: {
      variant: {
        primary:
          "border-[var(--primary)] bg-[var(--primary)] text-white shadow-[0_2px_0_var(--primary-shadow)] hover:border-[var(--primary-hover)] hover:bg-[var(--primary-hover)]",
        secondary:
          "border-[var(--line)] bg-[var(--paper)] text-[var(--ink)] hover:border-[color-mix(in_srgb,var(--ink)_32%,transparent)] hover:bg-[color-mix(in_srgb,var(--ink)_6%,var(--paper))]",
        ghost:
          "border-transparent bg-transparent text-[var(--ink)] hover:bg-[color-mix(in_srgb,var(--ink)_7%,transparent)]",
        danger:
          "border-[#c85143] bg-[#c85143] text-white hover:border-[#d65d4e] hover:bg-[#d65d4e]",
      },
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4 text-sm",
        lg: "h-12 px-5 text-sm",
        icon: "size-10 p-0",
        "icon-sm": "size-8 rounded-lg p-0",
      },
    },
    defaultVariants: { variant: "secondary", size: "md" },
  },
);

export type ButtonProps = React.ComponentProps<typeof ButtonPrimitive> &
  VariantProps<typeof buttonVariants>;

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return (
    <ButtonPrimitive
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { buttonVariants };
